import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { isNil } from '@web/utils';
import { EntryNotFoundException } from '@web/common';
import { SubscriptionSuspendReason } from '../enums/subscription-suspend-reason';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionSuspendReasonProviderService {
  private readonly entries = new Map<SubscriptionSuspendReason, string>([
    [SubscriptionSuspendReason.ByAdmin, 'Decyzja Administratora'],
    [SubscriptionSuspendReason.ByOwner, 'Decyzja użytkownika'],
    [
      SubscriptionSuspendReason.ByManyRejectedAttempts,
      'Zbyt wiele prób pobrania',
    ],
  ]);

  public labelFor(reason: SubscriptionSuspendReason): Observable<string> {
    const result = this.entries.get(reason);

    if (isNil(result)) {
      throw new EntryNotFoundException(
        `The entry for "${reason}" is not found.`,
      );
    }

    return of(result);
  }
}
